import React, { useEffect, useState } from "react";
import { InlineWidget } from "react-calendly";
import styled from "styled-components";

import { Flex } from "../../../container-components";


const CalendlyVessel = styled.div`
  & div.rich-text-view {
    display: none;
  }
  & a.fSwiAYLFAx _1EhgEMtB4Z {
    display: none !important;
  }
`;

const CalendlyStage = ({ isOrganization, chatbotUser, getInitialMessage }) => {
  const [calendlyConfig, setCalendlyConfig] = useState({ url: "", src: "" });

  const handleCalendlyCalendar = () => {
    const newCalendlyConfig = { url: "", src: "" };
    if (isOrganization) {
      newCalendlyConfig.src =
        "https://assets.calendly.com/assets/external/widget.js";
      newCalendlyConfig.url =
        "https://calendly.com/salusion-inquiry/salusion-support/30min";
    } else {
      newCalendlyConfig.src =
        "https://assets.calendly.com/assets/external/widget.js";
      newCalendlyConfig.url = "https://calendly.com/salusion/help";
    }

    setCalendlyConfig(newCalendlyConfig);
  };

  useEffect(() => {
    handleCalendlyCalendar();
  }, []);

  return (
    <Flex >
      {calendlyConfig?.url && (
        <InlineWidget
          url={calendlyConfig.url}
          styles={{ minWidth: "320px", height: "700px" }}
          prefill={{
            email: chatbotUser?.email || "",
            name: chatbotUser?.name,
            guests: ["giles@salusion.com"],
            customAnswers: {
              // a1: getInitialMessage({ chatbotUser }),
              a1: "",
            },
          }}
        />
      )}
    </Flex>
  );
};

export default CalendlyStage;
